import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import AuthController from "@controllers/auth.controller";
import AuthLayout from "@components/layout/AuthLayout";
import FormInput from "@components/layout/FormInput";
import InvitationController from "@/network/controllers/invitation.controller";
import Button from "@components/ui/Button";
import State, { STATE, InvitationState, LoginFlowState } from "@state";
import { useSession } from "@hooks/useSession";
import { useLocation } from "react-router-dom";
import { REDIRECT_AFTER_LOGIN } from "@/state/states/LoginFlowState";
import { v4 as uuidv4 } from "uuid";

export default function UserSignIn() {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { session, user } = useSession();

  const loginFlow = STATE[LoginFlowState.LOGIN_FLOW];
  const usedEmail = STATE[InvitationState.INVITATION_USED_EMAIL];
  const isInvitationFlow =
    loginFlow === LoginFlowState.FROM_INVITATION_FLOW && !!usedEmail;

  let rawInvitationId = STATE[InvitationState.INVITATION_CONTENT]?.id;
  let rawInvitationUserId = STATE[InvitationState.INVITATION_CONTENT]?.userId;

  const [formData, setFormData] = useState({
    email: isInvitationFlow ? usedEmail : "christophe.baizone+1@gmail.com",
    password: "password",
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirectTo = params.get("redirectTo");

    if (redirectTo && !STATE[REDIRECT_AFTER_LOGIN]) {
      const url = new URL(redirectTo, window.location.origin);
      const pathname = url.pathname;
      const search = url.search;
      State.setValue(REDIRECT_AFTER_LOGIN, { pathname, search });
    }
  }, []);

  useEffect(() => {
    console.log("=== user === UserSignIn.jsx === key: 973818 ===");
    console.dir(user, { depth: null, colors: true });
    console.log("=================================");
    console.log("=== session === UserSignIn.jsx === key: 723543 ===");
    console.dir(session, { depth: null, colors: true });
    console.log("=================================");
    console.log("=== STATE === UserSignIn.jsx === key: 178895 ===");
    console.dir(STATE, { depth: null, colors: true });
    console.log("=================================");
  }, [user, session]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const { email, password } = formData;
    //rawInvitationId = STATE[InvitationState.INVITATION_CONTENT]?.id;
    //rawInvitationUserId = STATE[InvitationState.INVITATION_CONTENT]?.userId;
    const rawContentInvitation = {...STATE[InvitationState.INVITATION_CONTENT]};

    console.log("→ isInvitationFlow:", isInvitationFlow);
    console.log('=== rawInvitationId === UserSignIn.jsx === key: 520691 ===');
    console.dir(rawInvitationId, { depth: null, colors: true })
    console.dir(rawInvitationUserId, { depth: null, colors: true })
    console.dir(rawContentInvitation, { depth: null, colors: true })
    console.log('=================================');

    const result = await AuthController.login(email, password);

    setLoading(false);
    console.log('=== result === UserSignIn.jsx === key: 280295 ===');
    console.dir(result, { depth: null, colors: true })
    console.log('=================================');

    if (result?.success) {
      if (isInvitationFlow) {
        const invitationId =
          rawInvitationId || STATE[InvitationState.INVITATION_CONTENT]?.id;
        const userId =
          result?.userId || result?.webhook?.response?.data?.userId;

        console.log(
          "=== { invitationId, userId } === UserSignIn.jsx === key: 358312 ==="
        );
        console.dir({ invitationId, userId }, { depth: null, colors: true });
        console.log("=================================");

        console.log("=== STATE === UserSignIn.jsx === key: 798953 ===");
        console.dir(STATE, { depth: null, colors: true });
        console.log("=================================");

        if (invitationId && userId && rawContentInvitation.invitation_type === "participant") {
          const acceptRes =
            await InvitationController.acceptParticipantInvitation(
              invitationId,
              userId,
              rawContentInvitation
            );

            console.log("→ acceptParticipantInvitation result:",);
            console.log('=== acceptRes === UserSignIn.jsx === key: 677372 ===');
            console.dir(acceptRes, { depth: null, colors: true })
            console.log('=================================');

           

          

          if (!acceptRes?.success) {
            console.error(
              "Failed to accept participant invitation:",
              acceptRes
            );
          }
        } else {
          console.warn(
            "Missing invitationId or userId for invitation acceptance."
          );
        }
      }

      const redirectData = STATE[REDIRECT_AFTER_LOGIN];
      if (redirectData) {
        navigate(redirectData.pathname + (redirectData.search || ""), {
          state: redirectData.state,
          replace: true,
        });
        State.setValue(REDIRECT_AFTER_LOGIN, null);
      } else {
        // navigate("/investigator-dashboard", { replace: true }); // fallback
      }
    } else {
      setError(result?.message || "Unable to sign in. Please try again.");
    }
  };

  return (
    <AuthLayout
      title="Welcome"
      subtitle="Please provide your e-mail and password to connect"
      logoSrc="/img/logo.png"
      imageSrc="/img/Oshimed sign in image - earth.png"
      formWidth="third"
      logoPosition="top"
    >
      <form className="space-y-2" onSubmit={handleSubmit}>
        <FormInput
          label="Email address"
          id="email"
          name="email"
          type="email"
          placeholder="name@email.com"
          required
          value={formData.email}
          onChange={handleChange}
          readOnly={isInvitationFlow}
          disabled={isInvitationFlow}
        />

        <FormInput
          label="Password"
          id="password"
          name="password"
          type="password"
          placeholder="At least 8 characters"
          required
          value={formData.password}
          onChange={handleChange}
        />

        <Button
          type="submit"
          variant="login"
          className="w-full font-bold"
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign in"}
        </Button>

        {error && <p className="text-red-500 text-sm text-center">{error}</p>}
      </form>

      {/*        <div className="mt-20 text-center">
        <Link
          to="/forgot-password"
          className="text-linkColor font-semibold hover:underline"
        >
          Forgot password ?
        </Link>
      </div>  */}

      {/* Sign Up */}
      <div className="mt-6 text-center">
        <p className="text-gray-600 font-bold">
          You don't have an account yet?{" "}
          <Link
            to="/user-signup"
            className="text-linkColor font-semibold hover:underline"
          >
            Sign up
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
